(() => {
  const popup = document.querySelector('[data-country-selector]');
  const dock = document.querySelector('[data-country-selector-dock]');
  const trigger = document.querySelector('[data-country-selector-trigger]');
  const triggerClose = document.querySelector('[data-country-selector-trigger-close]');
  if (!popup || !dock || !trigger || !triggerClose) return;

  const AUTO_SHOWN_KEY = 'walkingpad-country-selector-auto-shown-v1';
  const DOCK_HIDDEN_KEY = 'walkingpad-country-selector-dock-hidden-v1';
  const readStorage = (storageName, key) => {
    try {
      return window[storageName].getItem(key) === '1';
    } catch (_) {
      return false;
    }
  };
  const writeStorage = (storageName, key) => {
    try {
      window[storageName].setItem(key, '1');
    } catch (_) {
      // Storage can be blocked in private or restricted browser contexts.
    }
  };

  const dialog = popup.querySelector('[role="dialog"]');
  const search = popup.querySelector('[data-country-selector-search]');
  const items = [...popup.querySelectorAll('[data-country-selector-item]')];
  const empty = popup.querySelector('[data-country-selector-empty]');
  const recommendation = popup.querySelector('[data-country-selector-recommendation]');
  const recommendationName = popup.querySelector('[data-country-selector-recommendation-name]');
  let lastFocusedElement = null;

  const revealDock = () => {
    dock.hidden = readStorage('sessionStorage', DOCK_HIDDEN_KEY);
  };
  const close = () => {
    popup.hidden = true;
    revealDock();
    const focusTarget = lastFocusedElement && document.contains(lastFocusedElement) && lastFocusedElement !== document.body
      ? lastFocusedElement
      : trigger;
    if (!dock.hidden) focusTarget.focus({ preventScroll: true });
  };
  const open = ({ automatic = false } = {}) => {
    lastFocusedElement = document.activeElement;
    if (automatic) writeStorage('localStorage', AUTO_SHOWN_KEY);
    popup.hidden = false;
    dock.hidden = true;
    window.requestAnimationFrame(() => (search || dialog).focus({ preventScroll: true }));
  };

  popup.querySelectorAll('[data-country-selector-close]').forEach((button) => button.addEventListener('click', close));
  trigger.addEventListener('click', () => open());
  triggerClose.addEventListener('click', () => {
    dock.hidden = true;
    writeStorage('sessionStorage', DOCK_HIDDEN_KEY);
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) close(); });
  const normalize = (value) => (value || '').toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  const applyCountrySuggestion = (country) => {
    if (!country?.name) return false;
    const match = items.find((item) => normalize(item.dataset.countryName).includes(normalize(country.name)));
    if (!match) return false;
    match.dataset.countrySelectorRecommended = 'true';
    recommendationName.textContent = country.name;
    recommendation.hidden = false;
    return true;
  };
  const suggestCountryFromLocation = async () => {
    let country;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`, { headers: { Accept: 'application/json' } });
      if (response.ok) {
        const result = await response.json();
        country = result.suggestions?.[0]?.parts?.country || result.detected_values?.country;
      }
    } catch (_) {
      // The fallback below uses Shopify's current localization when the suggestion endpoint is unavailable.
    }
    applyCountrySuggestion(country || { name: popup.dataset.currentCountry });
  };
  const filterItems = () => {
    const query = normalize(search.value);
    let visible = 0;
    items.forEach((item) => {
      const matches = !query || normalize(`${item.dataset.search} ${item.textContent}`).includes(query);
      item.hidden = !matches;
      if (matches) visible += 1;
    });
    empty.hidden = visible !== 0;
  };
  search.addEventListener('input', filterItems);
  search.addEventListener('search', filterItems);
  search.addEventListener('keyup', filterItems);
  suggestCountryFromLocation();
  if (readStorage('localStorage', AUTO_SHOWN_KEY)) {
    revealDock();
  } else {
    const delay = Math.max(0, Number(popup.dataset.delay || 5)) * 1000;
    window.setTimeout(() => open({ automatic: true }), delay);
  }
})();
